import TimelineFeedCont from '../../../components/Common/TimelineFeed/TimelineFeedCont'
import CustomSpin from '../../../elements/CustomSpin'
import PageTitle from '../../../elements/PageTitle'
import React from 'react'
import { Breadcrumb, Card, Icon, Layout, Row, Tabs } from 'antd'
import { withRouter } from 'react-router-dom'
import SupplierDetails from '../../../components/Purchasing/Supplier/SupplierDetails'
import Profile from '../../../components/Purchasing/Supplier/Profile'
import Details from '../../../components/Purchasing/Supplier/Details'
import Banking from '../../../components/People/Member/Banking'
import Contracts from '../../../components/Purchasing/Supplier/Contracts'
import DocumentsCont from '../../../components/Common/Documents/DocumentsCont'
import { get } from 'lodash'
import CatalogsCont from '../../../components/Common/Catalogs/CatalogsCont'
import OrderList from '../../../components/Purchasing/Order/OrderList'

const { Content } = Layout
const { TabPane } = Tabs

function Supplier (props) {
  const {
    member,
    supplier,
    repsList,
    memberFetching,
    supplierFetching,
    cachedListOrders,
    fetchingOrders,
    fetchOrders,
    listOrders,
    companyOrder,
    onChangeCompanyOrder,
    repsListFetching,
    fetch,
  } = props

  return (
    <CustomSpin spinning={memberFetching}>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item>Purchasing</Breadcrumb.Item>
              <Breadcrumb.Item href="#/purchasing/suppliers/list">Vendors List</Breadcrumb.Item>
              <Breadcrumb.Item>{member.fn}</Breadcrumb.Item>
            </Breadcrumb>
            <PageTitle
              title={'Vendor Management Area'}
              subtitle={'Vendor Management Area.'}
              color={'#427035'}
              iconType={'file-unknown'}
            />
          </Row>
        </Card>

        <Row gutter={16} style={{ padding: 10 }}>
          <Card>
            <Details {...{ supplier, member }} />
            <Row style={{ paddingTop: '10px' }}>
              <Tabs
                defaultActiveKey={get(props, 'location.hash') || '#profile'}
                onChange={(key) => props.history.push(key)}>
                <TabPane
                  tab={
                    <span>
                      <Icon type="user"/>
                      Profile
                    </span>
                  }
                  key="#profiles">
                  <Profile {...{ repsList, member, fetching: repsListFetching, fetch }} />
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      <Icon type="info-circle-o"/>
                      Vendor Details
                    </span>
                  }
                  key="#details">
                  <SupplierDetails {...props} loading={supplierFetching}/>
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      <Icon type="bank"/>
                      Banking Details
                    </span>
                  }
                  key="#banks">
                  <Banking member={member} employee={supplier}/>
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      <Icon type="lock"/>
                      Accounts
                    </span>
                  }
                  key="#contracts">
                  <Contracts supplier={supplier} member={member} loading={supplierFetching}/>
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      <Icon type="windows"/> Products
                    </span>
                  }
                  key="#products">
                  <CatalogsCont member={member}/>
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      <Icon type="windows"/> Orders
                    </span>
                  }
                  key="#orders">
                  <OrderList
                    fetchingOrders={fetchingOrders}
                    fetchOrders={fetchOrders}
                    listOrders={listOrders}
                    companyOrder={companyOrder}
                    onChangeCompanyOrder={onChangeCompanyOrder}
                  />
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      <Icon type="folder-open"/>
                      Documents
                    </span>
                  }
                  key="#docs">
                  <DocumentsCont owner={supplier}/>
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      <Icon type="file-text"/>
                      Notes
                    </span>
                  }
                  key="#note">
                  <TimelineFeedCont owner={supplier._id} hideNotification={true}/>
                </TabPane>
              </Tabs>
            </Row>
          </Card>
        </Row>
      </Content>
    </CustomSpin>
  )
}

export default withRouter(Supplier)
